import React from 'react';
import {useTranslation} from 'react-i18next';
import {IElementQuestionAnswer, IElementQuestionnaireWithAnswers} from '../../../../../../incase-domain/elements/base/questionElementBase';
import {getAnswer, setCodebookAnswerComment} from '../../../../../../utils/codebook.utils';
import InputWithCharacterCounter from '../../../common/InputWithCharacterCounter';
import Modal from '../../../../../../incase-domain/components/modals/directory/Modal';
import {swapArrayElement} from '../../../../../../utils/utils';
import {MAX_COMMENT_LENGTH} from '../../../../../../incase-domain/validators/elements/constant';
import Button from '../../../../../../incase-domain/components/button/Button';

interface IChangeCommentProps {
    index: number;
    highlightedElement: IElementQuestionnaireWithAnswers;
    highlightedElementChangeHandler: {single: (field: keyof IElementQuestionnaireWithAnswers | string, value: unknown) => void};
    codebookAnswer?: IElementQuestionAnswer;
}

function ChangeComment({index, highlightedElementChangeHandler, highlightedElement, codebookAnswer}: IChangeCommentProps): JSX.Element {
    const {t} = useTranslation();

    const [isOpenCommentModal, setIsOpenCommentModal] = React.useState<boolean>(false);
    const [comment, setComment] = React.useState<string>('');

    const answer = getAnswer(index, highlightedElement, codebookAnswer);

    function commentChangeHandler(index: number, value: string): void {
        if (codebookAnswer) {
            setCodebookAnswerComment(codebookAnswer, highlightedElement, highlightedElementChangeHandler, value);
        } else {
            const changedAnswer = {...highlightedElement.answers[index]};
            changedAnswer.comment = value;
            const newAnswers = swapArrayElement(highlightedElement.answers, index, changedAnswer);
            highlightedElementChangeHandler.single('answers', newAnswers);
        }
    }

    return (
        <>
            <Button
                leading={answer.comment.length ? 'solar:chat-square-bold' : 'solar:chat-square-linear'}
                variant="ghost"
                square
                size="sm"
                color={answer.comment.length ? 'secondary' : 'primary'}
                key={`${index}-comment`}
                onClick={() => {
                    setIsOpenCommentModal(true);
                    setComment(answer.comment);
                }}
            />
            <Modal
                isOpen={isOpenCommentModal}
                onCancel={() => {
                    setIsOpenCommentModal(false);
                    setComment('');
                }}
                onConfirm={() => {
                    commentChangeHandler(index, comment);
                    setIsOpenCommentModal(false);
                    setComment('');
                }}
                header={`"${answer.text}"`}
                description={t('designSidepanel.joinCommentToAnswer')}
                icon="solar:chat-dots-bold"
                showConfirm
                showCancel
            >
                <InputWithCharacterCounter
                    className="c-sidepanel__input"
                    value={comment}
                    onChange={(value) => {
                        setComment(value);
                    }}
                    maxLength={MAX_COMMENT_LENGTH}
                    placeholder={t('designSidepanel.enterYourComment')}
                />
            </Modal>
        </>
    );
}

export default ChangeComment;
